let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aBYqD")).then(() => parcelRequire('dgxSt'));